import React, { useState, useEffect, useContext } from 'react';
import {addDays, format, parseISO} from "date-fns";

import * as net from "../../lib/net";
import Fr_Input from "../../lib/ui/fr_input";
import Fr_Cal from "../../lib/ui/fr_cal";
import Td_Sel from "../../lib/ui/td_sel";

import Pms_SzNota from "./sz_nota";
import Pms_Rvo from "../rv/fb/rvo.js";
import Pms_Nota from "../op/nota/nota";
import Wnd_Sel from "../../lib/ui/wnd_sel";
import sso from "../../sso";

class Pms_Sz extends React.Component {
  constructor(props, context) {
    super(props);

    this.state = {};
    this.state.ynq = [];
    this.state.aa = [];
    this.state.cols = {};
    this.state.ix = 0;
    this.state.sz_val = "";
    this.state.msg = {};
    this.state.wnds = {};
    this.state.szo = {};
    this.state.sza = [];
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close = () => {
        if(sso.wnds.szw == 1) {
            sso.wnds.szw = 0;
            return;
        }
		this.props.ctx.setState({ wnds: {} });
	};
    handleChange = (event, newValue) => {
        //alert(newValue);
        this.setState({ix: newValue});
      };
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  sz_do() {
    var self = this;

    if(this.state.szo.boknr) this.sz_boknr();
    if(this.state.szo.ftg) this.sz_ftg();
    if(this.state.szo.namn) this.sz_namn();
      if(this.state.szo.gst) this.sz_gst();
      if(this.state.szo.dt) this.sz_gst_dt();

    return;
  }
  sz_boknr() {
    var self = this;

    var prm = {};
    prm.req = "pms.sz.mys_boknr";
    prm.boknr = this.state.szo.boknr;
    //alert(JSON.stringify(prm));

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
        if(ret.ok != "000") {
            return;
        }
        self.setState({ sza: ret.rca });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
    return;
  }
  sz_ftg() {
    var self = this;

    var prm = {};
    prm.req = "pms.sz.mys_ftg";
    prm.ftg = this.state.szo.ftg;
    //alert(JSON.stringify(prm));

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            return;
        }
        self.setState({ sza: ret.rca });
        //self.setState({gsa: ret.rca });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
    return;
  }
  sz_namn() {
    var self = this;

    var prm = {};
    prm.req = "pms.sz.mys_namn";
    prm.namn = this.state.szo.namn;
    //alert(JSON.stringify(prm));

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            return;
        }
        self.setState({ sza: ret.rca });
        //self.setState({gsa: ret.rca });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
    return;
  }
    sz_gst() {
        var self = this;

        var prm = {};
        prm.req = "pms.sz.mys_gst";
        prm.namn = this.state.szo.gst;
        //alert(JSON.stringify(prm));

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret));

                if(ret.ok != "000") {
                    return;
                }
                self.setState({ sza: ret.rca });
                //self.setState({gsa: ret.rca });
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
        return;
    }
    sz_gst_dt() {
        var self = this;

        var prm = {};
        prm.req = "pms.sz.mys_gst_dt";
        prm.datum = this.state.szo.dt;
        //alert(JSON.stringify(prm));

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret));

                if(ret.ok != "000") {
                    return;
                }
                self.setState({ sza: ret.rca });
                //self.setState({gsa: ret.rca });
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
        return;
    }
    val_save (name, value) {
        var szo = this.state.szo;
        if(!szo[name]) {
            szo = {};
        }
        szo[name] = value;
        this.setState({szo: szo});
    }
    val_dt_save (name, value) {
        var szo = this.state.szo;
        //var dts = format(value, "yyyy-MM-dd");
        //alert(JSON.stringify(value));
        if(!szo[name]) {
            szo = {};
        }
        szo[name] = value;
        this.setState({szo: szo});
    }
    sz_edit(row) {
        var self = this;
        //alert(JSON.stringify(this.state.szo));
        if(this.state.szo.boknr) this.sz_rvsel(row);
        if(this.state.szo.ftg) this.sz_rvsel(row);
        if(this.state.szo.namn) this.sz_rvsel(row);
        if(this.state.szo.gst) this.sz_sel(row);
        if(this.state.szo.dt) this.sz_sel(row);
    }
    sz_rvo(row) {
        var self = this;
        var wnds = {};
        wnds.rvo = 1;
        wnds.boknr = row.boknr;
        this.props.ctx.setState({ wnds: wnds });
    }
    sz_rvo_copy(row) {
        var self = this;
        var wnds = {};
        wnds.rvo = 1;
        wnds.copy = row.boknr;
        this.props.ctx.setState({ wnds: wnds });
    }
    sz_nota() {
        var self = this;
        //alert(JSON.stringify(row.gsb00));
        var wnds = {};
        wnds.sznota = 1;
        self.setState({ wnds: wnds });
    }
    sz_sel_do(fkn) {
        var self = this;
        var row = this.state.srow;
        self.setState({msg: {} });
        if(fkn == "0") self.sz_rvo(row);
        if(fkn == "1") self.sz_nota(row);
    }
    sz_sel(row) {
        var self = this;
        var msg = { info: false, sel: true, text: "Öppna", text0: "BOKNING", text1: "NOTA", cb: "sz_sel_do" };
        self.setState({ msg: msg, srow: row });
    }
    sz_rvsel_do(fkn) {
        var self = this;
        var row = this.state.srow;
        self.setState({msg: {} });
        if(fkn == "0") self.sz_rvo_copy(row);
        if(fkn == "1") self.sz_rvo(row);
    }
    sz_rvsel(row) {
        var self = this;
        var msg = { info: false, sel: true, text: "SKAPA KOPIA ELLER ÖPPNA BOKNING?", text0: "KOPIA", text1: "ÖPPNA", cb: "sz_rvsel_do" };
        self.setState({ msg: msg, srow: row });
    }
    sz_keydown (e) {
        //e.preventDefault();
          const key = e.key;
          const keyCode = e.keyCode;
    
          if(keyCode == 13) {
              this.sz_do();
          };
          if(keyCode == 27) {
              //this.setState({sz_val: ""});
          };
      }
    
  render() {
    if(!this.props.show) return "";

    var title = this.props.title;
    if(!title) title = "Sök";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg mx_90 flex-col" style={ this.dlg_style() }>
        <div className="mx_content px-3 flex">

            <div className="flex-row" style={{padding:"5px",height:"35px"}}>
                    <div className="flex-col flex">
                        <div>SÖK</div>
                    </div>
                    <div className="flex-col">
                        <div>UPPDATERA</div>
                    </div>
            </div>
            <div className="divider_orange"></div>

            <div className="flex" style={{overflow: "auto"}}>
            <div className="flex flex-row" style={{border: "0px", margin: "0px", padding: "0px"}}>
                <table className="table" style={{border: "0px", margin: "0px", padding: "0px"}}>
                    <thead style={{fontSize: "12px", fontWeight: "normal", color: "#080", border: "0px", margin: "0px", padding: "0px"}}>
                    <tr>
                        <th style={{textAlign: "left"}}>Boknr</th>
                        <th style={{textAlign: "left"}}>Löppnr</th>
                        <th style={{textAlign: "left"}}>Företag</th>
                        <th style={{textAlign: "left"}}>Namn</th>
                        <th style={{textAlign: "left"}}>Ankomst</th>
                        <th style={{textAlign: "left"}}>Avresa</th>
                        <th style={{textAlign: "left"}}>Gäster</th>
                        <th style={{textAlign: "left"}}>Status</th>
                    </tr>
                    </thead>
                    <tbody style={{fontSize: "16px", color: "#000", border: "0px", margin: "0px", padding: "0px", borderBottom: "1px solid #ccc"}}>
                    { this.state.sza.map((row, key) =>
                    <tr key={key} onDoubleClick={() => this.sz_edit(row) }>
                        <td>{ row.boknr }</td>
                        <td>{ row.lopnr }</td>
                        <td>{ row.ftg }</td>
                        <td>{ row.namn }</td>
                        <td>{ row.ank }</td>
                        <td>{ row.avr }</td>
                        <td>{ row.nrg }</td>
                        <td>{ row.status }</td>
                    </tr>
                    )}
                    </tbody>
                </table>
             </div>
             </div>

             <div className="divider_orange"></div>
            <form className="cdi_f03 py-3">
            <div className="flex-row">
                <Fr_Input label="FÖRETAG" className="text-left w350" text={this.state.szo.ftg} getValue={(e)=> this.val_save("ftg", e) } onKeyDown={(e) => this.sz_keydown(e)} />
                <Fr_Input label="NAMN" className="text-left w350" text={this.state.szo.namn} getValue={(e)=> this.val_save("namn", e) } onKeyDown={(e) => this.sz_keydown(e)} />
            </div>
            <div className="flex-row">
                <Fr_Input label="BOKNR" className="text-left w250" text={this.state.szo.boknr} getValue={(e)=> this.val_save("boknr", e) } onKeyDown={(e) => this.sz_keydown(e)} />
            </div>
            <div className="flex-row">
                <Fr_Input label="GÄST" className="text-left w350" text={this.state.szo.gst} getValue={(e)=> this.val_save("gst", e) } onKeyDown={(e) => this.sz_keydown(e)} />
                <Fr_Cal above label="DATUM" className="text-left w250" text={this.state.szo.dt} getValue={(e)=> this.val_dt_save("dt", e) } />
            </div>
            </form>

        </div>

        <div className="mx_foot flex-row">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex"></div>
            <button className="btn btn-hw-blue w250" onClick={() => this.sz_nota() } >
                SÖK NOTA
            </button>
            <div className="flex"></div>
            <button className="btn btn-hw-green w250" onClick={(event) => this.sz_do(event) } >
                SÖK
            </button>
      </div>
    </div>
        { this.state.wnds.sznota ? <Pms_SzNota wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.rvo ? <Pms_Rvo wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.nota ? <Pms_Nota wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.msg.sel ? <Wnd_Sel msg={this.state.msg} ctx={this} /> : null }
    </div>
	;
	return html;
  };
}

export default Pms_Sz;